import { useEffect, useState } from "react";

// One-time reset of floating-helper positions so every user gets the tidy
// default stack again (Isaiah star on top, gift to the side, command center
// at the bottom). This clears any old dragged spots that left the star buried
// at the bottom. Runs once; FABs stay fully draggable afterward.
try {
  if (typeof window !== "undefined" && localStorage.getItem("iw_fab_reset_v2") !== "1") {
    ["iw_fab_pos_owl", "iw_fab_pos_star", "iw_fab_pos_gift", "iw_fab_pos_cc"].forEach((k) => {
      localStorage.removeItem(k);
      localStorage.removeItem(`${k}_side`);
    });
    localStorage.setItem("iw_fab_reset_v2", "1");
  }
} catch { /* SSR / quota safe */ }

// Shared "tidy mode" flag so a single tap can collapse ALL floating helpers
// (Isaiah star companion, Professor Owl guide, admin command-center) into one
// button on small phones — and bring them back.
const KEY = "iw_fabs_collapsed";
const EVT = "iw-fabs-collapsed";

export function getFabsCollapsed() {
  try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
}

export function setFabsCollapsed(v) {
  try { localStorage.setItem(KEY, v ? "1" : "0"); } catch {}
  try { window.dispatchEvent(new CustomEvent(EVT, { detail: { collapsed: !!v } })); } catch {}
}

// Hook: current collapsed state, kept in sync across every helper + the toggle.
export function useFabsCollapsed() {
  const [collapsed, setCollapsed] = useState(getFabsCollapsed);
  useEffect(() => {
    const h = (e) => setCollapsed(!!(e?.detail?.collapsed));
    window.addEventListener(EVT, h);
    return () => window.removeEventListener(EVT, h);
  }, []);
  return collapsed;
}
